var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-switch-wrapper"},[_c('div',{staticClass:"game-switch d-flex-v"},_vm._l((_vm.games),function(a){return _c('div',{key:a.productCode,staticClass:"game-icon",class:{
            'is-disabled': !a.isEnabled,
            'is-current': _vm.isCurrent(a.productCode)
        },on:{"click":function($event){return _vm.jumpPage(a)}}},[_c('el-avatar',{attrs:{"shape":"square","size":48,"src":_vm.$p(a.appIcon)}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }